"use client";
import { useRouter } from "next/navigation";
import { useState } from "react";
export default function Home() {
  const router = useRouter();
  const [currentState, setCurrentState] = useState("institute");
  const handleButtonClick = (link: string) => {
    window.open(link, '_blank', 'noopener noreferrer');
  };
  return (
    <div className="siteBg bgCover mvh100">
      <div className="clContainer">
        <div>
          <div className="clLogo">
            <img src="/img/clLogo.svg" alt="cl" />
          </div>
          <div className="headingBox">
            <div className="siteHeading">Step Into Eduverse</div>
            <div className="siteSubheading">
              Virtual Campus Tours, Counselling, classrooms and More.
            </div>
            <div className="clTab">
              <div className="loginSubmitInner tabGap">
                <button type="button" data-target="institues" className={`clTabJq siteTabBtn ${currentState == "institute" && "active"}`} onClick={() => setCurrentState("institute")}>
                  CL Centres
                </button>
                <button type="button" data-target="colleges" className={`clTabJq siteTabBtn ${currentState == "colleges" && "active"}`} onClick={() => setCurrentState("colleges")}>
                  Colleges
                </button>
                <button type="button" data-target="clVerse" className={`clTabJq siteTabBtn ${currentState == "clverse" && "active"}`} onClick={() => { router.push("/lobby"); setCurrentState("institute") }}>
                  CL Verse
                </button>
              </div>
            </div>
          </div>
          <div className={`clTabBox ${currentState == "institute" && "active"}`} id="institute">
            <div className="clTabBoxInner">
              <div className="clCard">
                <div className="clCardImage">
                  <img src="/img/cardImg.jpg" alt="" />
                </div>
                <div className="clCardDes">
                  <div className="cardHeading">Career Launcher, Noida</div>
                  <div className="cardDes">
                    1st Floor, C - 30/6, opp. INDIAN OIL APARTMENT, C Block, Phase 2, Industrial Area, Sector 62, Noida, Uttar Pradesh 201301
                  </div>
                  <div className="cardBoxFooter">
                    <div className="cfRow">
                      <span><img src="/img/phIcon.svg" alt="" /></span>
                      0120-431 2136
                    </div>

                    <div className="cfRow">
                      <span><img src="/img/email.svg" alt="" /></span>
                      noida.sec62@careerlauncher.com
                    </div>
                  </div>
                </div>
              </div>
              <div className="clCardFooter">
                <button type="submit" className="siteBtnOutline" onClick={() => handleButtonClick("https://vcg.vosmos.live/CLCenterNoida")}>
                  Take Virtual Tour
                </button>
              </div>
            </div>
            <div className="clTabBoxInner">
              <div className="clCard">
                <div className="clCardImage">
                  <img src="/img/cardImg.jpg" alt="" />
                </div>
                <div className="clCardDes">
                  <div className="cardHeading">Career Launcher, Dwarka</div>
                  <div className="cardDes">
                    2nd Floor, Plot No.23, Sector 12A Rd, above IDFC Bank, Block A, Sector 12 Dwarka, Dwarka, New Delhi, Delhi, 110078
                  </div>
                  <div className="cardBoxFooter">
                    <div className="cfRow">
                      <span><img src="/img/phIcon.svg" alt="" /></span>
                      011 4357 6596
                    </div>

                    <div className="cfRow">
                      <span><img src="/img/email.svg" alt="" /></span>
                      dwarka@careerlauncher.com
                    </div>
                  </div>
                </div>
              </div>
              <div className="clCardFooter">
                <button type="submit" className="siteBtnOutline" onClick={() => handleButtonClick("https://vcg.vosmos.live/CLCenterDwarka")}>
                  Take Virtual Tour
                </button>
              </div>
            </div>
          </div>
          <div className={`clTabBox ${currentState == "colleges" && "active"}`} id="colleges">
            <div className="clTabBoxInner">
              <div className="clCard">
                <div className="clCardImage">
                  <img src="/img/cardImg.jpg" alt="" />
                </div>
                <div className="clCardDes">
                  <div className="cardHeading">FOSTIIMA Business School</div>
                  <div className="cardDes">
                    Plot No. HAF-1, Dwarka Sector 9, New Delhi, Delhi 110077
                  </div>
                  <div className="cardBoxFooter">
                    <div className="cfRow">
                      <span><img src="img/phIcon.svg" alt="" /></span>
                      98918 44585
                    </div>

                    <div className="cfRow">
                      <span><img src="/img/email.svg" alt="" /></span>
                      admissions@fostiima.org
                    </div>
                  </div>
                </div>
              </div>
              <div className="clCardFooter">
                <button type="submit" className="siteBtnOutline" onClick={() => handleButtonClick("https://vcg.vosmos.live/Fastiima")}>
                  Take Virtual Tour
                </button>
              </div>
            </div>
            <div className="clTabBoxInner">
              <div className="clCard">
                <div className="clCardImage">
                  <img src="/img/cardImg.jpg" alt="" />
                </div>
                <div className="clCardDes">
                  <div className="cardHeading">GNIOT Group of Institutions</div>
                  <div className="cardDes">
                    Plot No. 7, Knowledge Park II, Greater Noida, Uttar Pradesh 201310
                  </div>
                  <div className="cardBoxFooter">
                    <div className="cfRow">
                      <span><img src="img/phIcon.svg" alt="" /></span>
                      18002746969
                    </div>

                    <div className="cfRow">
                      <span><img src="img/email.svg" alt="" /></span>
                      admission@gniot.net.in
                    </div>
                  </div>
                </div>
              </div>
              <div className="clCardFooter">
                <button type="submit" className="siteBtnOutline" onClick={() => handleButtonClick("https://vcg.vosmos.live/Gniot")}>
                  Take Virtual Tour
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
